import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Truck, MessageCircle } from 'lucide-react';
import PolicyLayout from './PolicyLayout';
import { getWhatsAppLink } from '../lib/utils';

function ShippingPolicy() {
  return (
    <>
      <Helmet>
        <title>Shipping Policy - OldCoinage.com</title>
        <meta name="description" content="Learn about OldCoinage.com's shipping methods and delivery timelines." />
      </Helmet>

      <PolicyLayout title="Shipping Policy" lastUpdated="March 15, 2024">
        <div className="bg-purple-50 border border-purple-100 rounded-lg p-6 mb-8">
          <div className="flex items-start gap-4">
            <Truck className="h-6 w-6 text-purple-600 mt-1" />
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Secure & Insured Delivery</h2>
              <p className="text-gray-600">
                Every shipment is fully insured and carefully packaged to ensure safe delivery.
              </p>
            </div>
          </div>
        </div>

        <h2>Delivery Timeline</h2>
        <p>
          Standard delivery takes 2-5 business days across India. Actual delivery time may vary based on your location and order timing.
        </p>

        <h2>Shipping Costs</h2>
        <p className="mb-4">
          Base shipping cost starts at ₹75 and may vary up to ₹100 depending on:
        </p>
        <ul className="mb-6 space-y-2">
          <li>Package weight</li>
          <li>Delivery distance</li>
          <li>Shipping location accessibility</li>
          <li>Special handling requirements</li>
        </ul>

        <div className="bg-gray-50 border border-gray-100 rounded-lg p-6 mb-8">
          <h3 className="font-semibold text-gray-900 mb-3">Shipping Cost Factors</h3>
          <div className="space-y-2 text-gray-600">
            <p>The final shipping cost is calculated based on:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Total weight of the items</li>
              <li>Distance from our fulfillment center</li>
              <li>Delivery location type (metro/non-metro)</li>
              <li>Special packaging requirements</li>
            </ul>
          </div>
        </div>

        <h2>Packaging</h2>
        <p>
          Your collectibles are packaged with utmost care using:
        </p>
        <ul>
          <li>Custom protective cases</li>
          <li>Shock-absorbing materials</li>
          <li>Tamper-evident seals</li>
          <li>Discreet outer packaging</li>
        </ul>

        <h2>Tracking & Insurance</h2>
        <p>
          All shipments include:
        </p>
        <ul>
          <li>Real-time tracking updates</li>
          <li>Delivery confirmation</li>
          <li>Proof of delivery</li>
        </ul>

        <h2>International Shipping</h2>
        <p>
          Currently, we only ship within India. International shipping will be available soon.
        </p>

        <div className="bg-primary-50 border border-primary-100 rounded-lg p-6 mt-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Shipping Questions?</h2>
          <p className="text-gray-600 mb-4">
            Contact our shipping support team for assistance:
          </p>
          <a
            href={getWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-full hover:bg-primary-700 transition-colors font-medium"
          >
            <MessageCircle className="h-5 w-5" />
            Chat on WhatsApp
          </a>
          <p className="text-sm text-gray-500 mt-4">
            Business Hours: Monday to Saturday, 9 AM to 6 PM IST
          </p>
        </div>
      </PolicyLayout>
    </>
  );
}

export default ShippingPolicy;